var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapefileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1f3c88"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 8,
    width: 40,
    height: 48,
    rx: 2,
    ry: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 14,
    width: 32,
    height: 4,
    rx: 1,
    ry: 1,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 22,
    width: 24,
    height: 4,
    rx: 1,
    ry: 1,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 30,
    width: 28,
    height: 4,
    rx: 1,
    ry: 1,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 44,
    width: 40,
    height: 12,
    rx: 2,
    ry: 2,
    fill: "#1f3c88"
  }), /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 54,
    fontFamily: "Arial, sans-serif",
    fontSize: 12,
    textAnchor: "middle",
    fill: "#fff"
  }, "SHP"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapefileIcon);
export default __webpack_public_path__ + "static/media/shapefileIcon.0ce44962549324ad7d24ab753ddd54e2.svg";
export { ForwardRef as ReactComponent };